/* eslint-disable no-unused-vars */
/* global G */
import { curry } from 'lib/util'
import find from 'lib/sequence/component/children/find'

/**
 * Get Context Tabs Event Handler
 *
 * Searches the action component for a component named `<context>Tabs` and returns it, if it
 * couldn't be found, it'll return the `tabs` component if found.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {Gaia.Component.Spec} component  the current action's main component
 * @param {Gaia.PlatformEvent} event    information about the event that triggered this handler
 * @returns {Object|undefined}
 */
const getContextTabs = (module, component, event) => {
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
  const { tabs: commonTabs, [`${module[G.ADAPTER][G.SESSION][G.STATE][G.CONTEXT]}Tabs`]: contextTabs } = find(actionComponent)

  return contextTabs || commonTabs
}

export default curry(getContextTabs)
